import React from 'react';
import {Logo} from './Logo';
import {NavItem} from './NavItem';

import {Flag} from './Flag'

export class Nav extends React.Component {
  
  render() {
    return (
   <nav className="navbar" id="header-navbar">
    <div className="container-fluid"> 
      <div className="navbar-header">	
        <Logo/> 
       </div>
       <div className="collapse navbar-collapse" id="myNavbar" >
         <NavItem/>
         <Flag/>
        </div>
       </div> 
    </nav>
     
     );
  }
}


// WEBPACK FOOTER //
// ./src/components/Nav/Nav.js